import React from "react";
import { LANDING_PAGE_PREPERATION_SECTION_BOOKS } from "../../constants/text_constants";
import SectionHeading from "./SectionHeading";
import { ScrollArea } from "../../components/ui/scroll-area";
import BookCard from "./BookCard";
import { Link } from "react-router-dom";
import { UNPROTECTED_ROUTES } from "../../routes/routes";
const PreperationSectionBooks = ({ books }) => {
  return (
    <div className="flex flex-col items-center lg:mt-[2rem] mt-[0rem]">
      <SectionHeading
        heading={LANDING_PAGE_PREPERATION_SECTION_BOOKS?.heading}
        subHeading={LANDING_PAGE_PREPERATION_SECTION_BOOKS?.subHeading}
        headingColor={"#130C40"}
      />
      <div className="border border-gray-200 md:h-[40rem] h-[23rem] w-full rounded-xl p-4 overflow-y-auto grid grid-cols-2 gap-2 shadow-2xl bg-white">
        {books.map((ele, i) => (
          <BookCard key={i} {...ele} />
        ))}
      </div>
      <div className="flex justify-center items-center md:mt-16 mt-8">
        <Link to={UNPROTECTED_ROUTES?.booksAll}>
          <button className="px-5 py-1 text-l font-bold text-white bg-gradient-to-r from-cyan-400 to-purple-600 rounded-full shadow-lg hover:-translate-y-1 hover:shadow-2xl transition-all">
            <span className="drop-shadow-md">View All</span>
          </button>
        </Link>
      </div>
    </div>
  );
};

export default PreperationSectionBooks;
